// TODO: Add types to accordion
import logger from '3-foundation/Logging/logger';

interface Props {
	content: {
		contentType: 'accordion';
		properties: {
			title: string;
			accordionItems: {
				items: {
					content: {
						contentType: 'accordionItem';
						id: string;
						properties: {
							title: string;
							htmlContent: Umbraco.RichText;
						};
					};
					settings: { properties: { openByDefault: false } };
				}[];
			};
		};
	};
	settings: {
		properties: {
			allowMultiple: boolean;
		};
	};
}

export const mapAccordion = ({ content, settings }: Props): Content.ContentModule => {
	const { title, accordionItems } = content?.properties ?? {};

	try {
		return {
			documentType: content?.contentType,
			content: {
				properties: {
					title: title,
					accordionItems: accordionItems.items?.map(({ content, settings }) => {
						const { title, htmlContent } = content?.properties ?? {};
						return {
							content: {
								properties: {
									id: content?.id?.split('-')?.at(-1) ?? null,
									title: title ?? null,
									htmlContent: htmlContent?.markup ?? null,
								},
							},
							settings: {
								properties: {
									openByDefault: settings.properties.openByDefault,
								},
							},
						};
					}),
				},
			},
			settings: {
				properties: {
					allowMultiple: settings.properties.allowMultiple,
				},
			},
		};
	} catch (e) {
		logger.error(`Could not map Accordion \nCause: ${e}`);
		throw new Error(`Could not map Accordion \nCause: ${e}`, e);
	}
};
